<template>
  <div class="menu-item">
    <div v-for="item in menu" :key="item.name">
      <el-submenu v-if="item.children.length !== 0" :index="item.path">
        <!-- el-submenu 表示还有子菜单，不是可路由的节点 -->
        <template v-slot:title>
          <i :class="item.icon" :style="{color:(col == '#000' ? '#bdbdbd' : '#000')}"></i>
          <span>{{item.name}}</span>
        </template>

        <!-- 递归调用组件自身 -->
        <menu-item :menu="item.children"></menu-item>
      </el-submenu>

      <router-link :to="item.path" tag="li" v-else>
        <el-menu-item :index="item.path">
          <!-- el-menu-item 表示菜单节点 -->
          <template v-slot:title>
            <i :class="item.icon" :style="{color:(col == '#000' ? '#bdbdbd' : '#000')}"></i>
            <span>{{item.name}}</span>
          </template>
        </el-menu-item>
      </router-link>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MenuItem',
    props: {
      menu: Array,
      col: String
    }
  }
</script>

<style scoped>

</style>
